import { Tooltip as MuiTooltip } from '@mui/material';
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Typography from '../Typography/Typography';

interface Props extends TooltipProps {
  maxWidth?: number;
}

export const Tooltip = styled(
  ({ className, title, ...props }: Props) => (
    <MuiTooltip
      arrow
      classes={{ tooltip: className, arrow: className }}
      title={title && <Typography variant="buttonSm">{title}</Typography>}
      {...props}
    />
  ),
  { shouldForwardProp: propName => propName !== 'maxWidth' && propName !== 'touchRippleRef' }
)(({ theme, maxWidth }) => ({
  [`&.${tooltipClasses.arrow}`]: {
    color: theme.palette.grey[500]
  },
  [`&.${tooltipClasses.tooltip}`]: {
    maxWidth: maxWidth || 300,
    backgroundColor: theme.palette.grey[500],
    boxShadow: theme.customShadows.z12,
    padding: theme.spacing(1.25, 1.5)
  }
}));

export default Tooltip;
